///   Localhost & AWS Fork 1
export const hardhat = {
  levEngineAddress: '0x9Fcca440F19c62CDF7f973eB6DDF218B15d4C71D',
  positionTokenAddress: '0x3C1Cb427D20F15563aDa8C249E71db76d7183B6c',
  coordinatorAddress: '0x71a0b8A2245A9770A4D887cE1E4eCc6C1d4FF28c',
  archTokenAddress: '0x0a17FabeA4633ce714F1Fa4a2dcA62C3bAc4758d',
  paramStoreAddress: '0xC1e0A9DB9eA830c52603798481045688c8AE99C2',
  lvUSDAddress: '0x5e6CB7E728E1C320855587E1D9C6F7972ebdD6D5',
  ousdAddress: '0x2A8e1E676Ec238d8A992307B495b45B3fEAa5e86',
  cdpAddress: '0x1c9fD50dF7a4f066884b58A05D91e4b55005876A',
  vaultAddress: '0x22a9B82A6c3D2BFB68F324B2e8367f346Dd6f32a',
  zapperAddress: '0xFD2Cf3b56a73c75A7535fFe44EBABe7723c64719',
  usdtAddress: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
  usdcAddress: '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48',
  daiAddress: '0x6b175474e89094c44da98b954eedeac495271d0f',
};

///   Localhost & AWS Fork 2
// export const hardhat = {
//   levEngineAddress: '0x3C1Cb427D20F15563aDa8C249E71db76d7183B6c',
//   positionTokenAddress: '0x22a9B82A6c3D2BFB68F324B2e8367f346Dd6f32a',
//   coordinatorAddress: '0xAe120F0df055428E45b264E7794A18c54a2a3fAF',
//   archTokenAddress: '0xC1e0A9DB9eA830c52603798481045688c8AE99C2',
//   paramStoreAddress: '0x1c9fD50dF7a4f066884b58A05D91e4b55005876A',
//   lvUSDAddress: '0x6A59CC73e334b018C9922793d96Df84B538E6fD5',
//   ousdAddress: '0x2A8e1E676Ec238d8A992307B495b45B3fEAa5e86',
//   cdpAddress: '0x71a0b8A2245A9770A4D887cE1E4eCc6C1d4FF28c',
//   vaultAddress: '0x95775fD3Afb1F4072794CA4ddA27F2444BCf8Ac3',
//   zapperAddress: '0x0Dd99d9f56A14E9D53b2DdC62D9f0bAbe806647A',
//   usdtAddress: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
//   usdcAddress: '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48',
//   daiAddress: '0x6b175474e89094c44da98b954eedeac495271d0f',
// };

/// Mainnet: DryRun & Live
export const mainnet = {
  levEngineAddress: '0x03dc7Fa99B986B7E6bFA195f39085425d8172E29',
  positionTokenAddress: '0x14c6A3C8DBa317B87ab71E90E264D0eA7877139D',
  coordinatorAddress: '0x58c968fADa478adb995b59Ba9e46e3Db4d6B579d',
  archTokenAddress: '0x73C69d24ad28e2d43D03CBf35F79fE26EBDE1011',
  paramStoreAddress: '0xcc6Ea29928A1F6bc4796464F41b29b6d2E0ee42C',
  lvUSDAddress: '0x94A18d9FE00bab617fAD8B49b11e9F1f64Db6b36',
  ousdAddress: '0x2A8e1E676Ec238d8A992307B495b45B3fEAa5e86',
  cdpAddress: '0x229a9733063eAD8A1f769fd920eb60133fCCa3Ef',
  vaultAddress: '0x4c12c57C37Ff008450A2597e810B51B2BbA0383A',
  usdtAddress: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
  usdcAddress: '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48',
  daiAddress: '0x6b175474e89094c44da98b954eedeac495271d0f',
  zapperAddress: '0x624f570C24d61Ba5BF8FBFF17AA39BFc0a7b05d8',
};
